import axios from "@galaxy/modules/Core/resources/js/axiosBuilder";

export default async function(richtext = false) {
    // Request data.
    return await axios.get('/galaxy/crud/' + ($('html').data('prefix') !== undefined ? $('html').data('prefix') : 'admin/') + 'form/ckeditor/database-list-styles/data', { params: { richtext: richtext } });
}
